<template>
  <vuestic-widget class="no-padding no-v-padding">
    <div class='vuestic-breadcrumbs'>
      <router-link :to="'/'" class="crumb">{{'breadcrumbs.home' | translate}}<i class="fa fa-chevron-right"></i>
      </router-link>
      <router-link
        v-for="(item, index) in breadcrumbs"
        :to="(item.meta && item.meta.to) || {path: item.path}"
        :key="index"
        class="crumb"
        v-bind:class="{ disabled: !((item.meta && item.meta.to) || item.path) || item.meta.breadcrumbDisabled }"
      >
        {{item.meta.title | translate}}<i class="fa fa-chevron-right"></i>
      </router-link>
    </div>
  </vuestic-widget>
</template>

<script>
  export default {
    name: 'vuestic-breadcrumbs',
    props: {
      breadcrumbs: {
        type: Array,
        default: [],
      },
    },
  };
</script>

<style lang='scss' scoped>
  @import '../../../sass/variables';

  .vuestic-breadcrumbs {
    height      : $breadcrumbs-height;
    display     : flex;
    align-items : center;

    .crumb {
      &.disabled {
        pointer-events : none;
      }
      &:last-child i {
        display : none;
      }

      i {
        padding   : 0 5px;
        color     : $brand-primary;
        font-size : $breadcrumbs-arrow-font;
      }
    }

    a {
      color : $breadcrumbs-gray;
      &:hover {
        color : $brand-primary;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/vuestic-theme/vuestic-components/vuestic-breadcrumbs/VuesticBreadcrumbs.vue